import React from 'react';
import { Button } from '@clayui/core';
import './CustomButton.css';

interface SubmitButtonProps {
    onClick?: () => void;
    type?: 'button' | 'submit' | 'reset';
    style?: React.CSSProperties;
    label: string;
    disabled?: boolean;
}

const CustomButton: React.FC<SubmitButtonProps> = ({
    onClick,
    type = 'submit', // default to 'submit' if not provided
    label,
    disabled,
    style
}) => {
    return (
        <Button
            type={type}
            onClick={onClick}
            className={label === "Assign to Another Manager" || label === 'Cancel' || label === 'Need Revision' || label === "Decline" || label == "Decline Request" || label == "Request More Information" || label == "Arrange Qualification Meeting" || label == "Reject" ? 'reject-button' : 'custom-button'}
            disabled={disabled}
            style={style}
        >
            {label}
        </Button>
    );
};

export default CustomButton;
